import React, { useCallback, useEffect, useState } from "react";
import FilterWrapper from "../Filters/FilterWrapper";
import GridContainer from "../GridView/GridContainer";
import SalesVolumeList from "./SalesVolumeList";

const SalesVolume = () => {
  const [gridView, setGridView] = useState(true);
  const changeViewType = useCallback(
    (value) => {
      setGridView(value);
    },
    [gridView]
  );
  const data = [
    {
      image: "/img/list-img.png",
      timeAgo: "6 hours ago",
      title: "CryptoPunk 8013",
      desc: "Male, Cigarette, Wild Hair, Normal Beard Black",
      price: "$ 310,618.38 (99.0000 ETH)",
      buyer: "0912kdhd...jkdashid098",
      seller: "0912kdhd...jkdashid098",
    },
    {
      image: "/img/list-img.png",
      timeAgo: "6 hours ago",
      title: "CryptoPunk 8013",
      desc: "Male, Cigarette, Wild Hair, Normal Beard Black",
      price: "$ 310,618.38 (99.0000 ETH)",
      buyer: "0912kdhd...jkdashid098",
      seller: "0912kdhd...jkdashid098",
    },
    {
      image: "/img/list-img.png",
      timeAgo: "6 hours ago",
      title: "CryptoPunk 8013",
      desc: "Male, Cigarette, Wild Hair, Normal Beard Black",
      price: "$ 310,618.38 (99.0000 ETH)",
      buyer: "0912kdhd...jkdashid098",
      seller: "0912kdhd...jkdashid098",
    },
    {
      image: "/img/list-img.png",
      timeAgo: "6 hours ago",
      title: "CryptoPunk 8013",
      desc: "Male, Cigarette, Wild Hair, Normal Beard Black",
      price: "$ 310,618.38 (99.0000 ETH)",
      buyer: "0912kdhd...jkdashid098",
      seller: "0912kdhd...jkdashid098",
    },
    {
      image: "/img/list-img.png",
      timeAgo: "6 hours ago",
      title: "CryptoPunk 8013",
      desc: "Male, Cigarette, Wild Hair, Normal Beard Black",
      price: "$ 310,618.38 (99.0000 ETH)",
      buyer: "0912kdhd...jkdashid098",
      seller: "0912kdhd...jkdashid098",
    },
    {
      image: "/img/list-img.png",
      timeAgo: "6 hours ago",
      title: "CryptoPunk 8013",
      desc: "Male, Cigarette, Wild Hair, Normal Beard Black",
      price: "$ 310,618.38 (99.0000 ETH)",
      buyer: "0912kdhd...jkdashid098",
      seller: "0912kdhd...jkdashid098",
    },
  ];
  return (
    <div>
      <FilterWrapper
        title={"Sales Lists"}
        viewType={gridView}
        changeViewType={changeViewType}
        view={true}
      />
      {gridView ? <GridContainer list={data} /> : <SalesVolumeList />}
    </div>
  );
};

export default SalesVolume;
